<ion-header *ngIf="!header_none && DBservice.ismobile" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons class="white_color" slot="start" *ngIf="DBservice.ismobile">
      <ion-back-button defaultHref="/product-list"></ion-back-button>
    </ion-buttons>
    <ion-title class="white_color">{{title}} Product</ion-title>
    <!-- <div (click)="setting()" class="setting mouse">
      <ion-icon name="settings"></ion-icon> Setting
    </div> -->
    <!-- <ion-buttons slot="end">
      <ion-button class="save-btn" (click)="post_product()" [style.background]="'#490e6f'">
        <ion-icon src="assets/icon/{{title == 'Add'?'add.svg':'save.svg'}}"></ion-icon>
        {{title == 'Add'?'Add':'Save'}}
      </ion-button>
    </ion-buttons> -->
    <!-- <ion-buttons slot="end" *ngIf="!DBservice.ismobile">
      <ion-button class="close-btn" (click)="goto_page('productlist')" routerDirection="root" [style.background]="'#e9e9e9'">
        <ion-icon src="assets/icon/close.svg"></ion-icon> Close
      </ion-button>
    </ion-buttons> -->
  </ion-toolbar>
</ion-header>

<div class="list">
  <div *ngIf="!DBservice.ismobile" class="d__flex header just-s">
    <!-- <ion-title class="margin p0" *ngIf="!DBservice.ismobile">Products</ion-title> -->
    <!-- <h2 class="fnt-20  myAccount-titles">{{title}}</h2> -->
    <div class="parent_head">
      <div class="head_img">
        <img [src]="DBservice.product_img(product.image)">
      </div>
      <div *ngIf="title != 'Add';else no_value" class="head_sub">
        <h6 class="bold_name">{{product.item}}</h6>
        <p *ngIf="product.sku" class="small_name">{{product.sku}}</p>
      </div>
  
      <ng-template #no_value>
        <div class="head_sub">
          <h6 class="bold_name">Add a new product</h6>
        </div>
      </ng-template>
  
  
  
      <ion-icon *ngIf="is_not_shown" (click)="navigate_to_full_screen(product)" class="icon mouse"
        name="expand-outline"></ion-icon>
    </div>
    <div class="d__flex" *ngIf="!is_not_shown">
      <ion-button class="close_button" routerDirection="root" (click)="goto_page('product-list')" fill="clear"
        size="small"><span class="span">
          <ion-icon name="close-outline"></ion-icon>
        </span>Close</ion-button>
  
      <ion-button fill="clear" class="save-btn" (click)="post_product()" [style.background]="'#490e6f'">
        <span class="span">
          <ion-icon src="/assets/icon/save.svg"></ion-icon>
        </span>Save
        <!-- <span class="span"><ion-icon src="/assets/icon/{{title == 'Add'?'add.svg':'save.svg'}}"></ion-icon></span>
          {{title == 'Add'?'Add':'Save'}} -->
      </ion-button>
    </div>
  </div>
  <div [class.view_products]="is_not_shown" class="align-un" [class.d__flex]="!DBservice.ismobile">
    <div *ngIf="!is_not_shown && !DBservice.ismobile" class="side-bar">
      <!--  -->
      <div *ngFor="let item of sidebar" [class.display_none]="(!DBservice.variant_shown && item.title == 'Variants') || (title == 'Add' && item.title == 'SEO')" #category_content class="side-bar-options mouse" [class.active]="current_value == item.name" (click)="goto_center(item)">
        <div class="">{{item.title}}</div>
      </div>
    </div>
    <div class="flex-1" [class.mt-50]="title == 'Add' && DBservice.ismobile">
      <div [id]="sidebar[0].name" class="images__container box__">
        <!-- <h6 class="title__">Product Images</h6> -->
        <div class="d__flex align-c just-s">
          <h6 class="title__ ">Images</h6>
          <!-- <p class="m-0 fnt-14">Images of the product</p> -->
          <!-- <ion-button fill="clear" class="ion-text-capitalize fnt-12 add__image__btn" (click)="add_image()">Add /Edit</ion-button> -->
          <!-- route_id ? add_image() : DBservice.alert('Please save the document and then try uploading images') -->
        </div>
        <!-- ;else no_image  -->
        
        <div *ngIf="product && (product.product_images && product.product_images.length != 0);else no_image" class="image__container d__flex gap-10">
          <!-- {{product | json}} -->
          <!-- <div class="image d__flex just-c" *ngFor="let item of product.product_images;index as i">
            <img (click)="open_gallery(item,i)" *ngIf="item.detail_thumbnail else file_data" [src]="DBservice.product_img(item.detail_thumbnail)"> -->
          <fiv-gallery #gallery *ngIf="!DBservice.ismobile">
            <fiv-gallery-toolbar position="top">
              <fiv-gallery-toolbar-content>
                <ion-toolbar color="transparent">
                    <ion-icon class="mouse" (click)="gallery.close()" name="close-outline"></ion-icon>
                </ion-toolbar>
              </fiv-gallery-toolbar-content>
            </fiv-gallery-toolbar>
            <div id="gallery">
              <div class="image" *ngFor="let item of product.product_images" size="4" sizeMd="4">
                <fiv-gallery-image class="fiv_gallery_image" [src]="item.detail_thumbnail ? DBservice.product_img(item.detail_thumbnail) : item.filedata"></fiv-gallery-image>
              </div>
  
              <div (click)="add_image()" class="image d__flex just-c add_img">
                <ion-icon name="add-outline"></ion-icon> <span>Add /Edit</span>
              </div>
            </div>
          </fiv-gallery>
  
          <div *ngIf="DBservice.ismobile" class="img_sub_gallery">
            <div *ngFor="let item of product.product_images" class="img_div">
              <img class="image_div2" (click)="image_show(item)" [src]="item.detail_thumbnail ? DBservice.product_img(item.detail_thumbnail) : item.filedata">
            </div>
  
            <div (click)="add_image()" class="image d__flex just-c add_img">
              <ion-icon name="add-outline"></ion-icon> <span>Add /Edit</span>
            </div>
  
            <div id="myModal" class="modal">
              <ion-icon class="close" name="close" (click)="close()">&times;</ion-icon>
              <img class="modal-content" src="https://images.pexels.com/photos/268533/pexels-photo-268533.jpeg?cs=srgb&dl=pexels-pixabay-268533.jpg&fm=jpg" id="img01">
              <div id="caption"></div>
            </div>
          </div>
  
  
          <!-- </div> -->
  
        </div>
        <ng-template #no_image>
          <div class="image__container d__flex gap-10">
            <div (click)="add_image()" class="image d__flex just-c add_img mouse">
              <ion-icon name="add-outline"></ion-icon><span>Add /Edit</span>
            </div>
          </div>
          <!-- <p class="ion-text-center">No Images Found.!</p> -->
        </ng-template>
      </div>
      <div [id]="sidebar[1].name" class="box__">
        <!-- [current_value]="current_value" -->
  
        <app-dynamic-form [myform]="product_form" [form_values]="product"
          [box_width]="DBservice.ismobile ? undefined: (input_box_width ? input_box_width : '33.333%')"
          [submitted]="submitted" [form_data]="form_data" (get_remove_add_mandorty)="get_remove_add_mandorty($event)" current_value="product_info" [title]="title"></app-dynamic-form>
      </div>


      <!-- <ng-container [ngSwitch]="current_value"> -->
      <!-- *ngSwitchCase="'images'" -->
      <div *ngIf="false" [id]="sidebar[2].name" class="box__">
        <!-- [current_value]="current_value" -->
        <app-dynamic-form [myform]="product_form" [form_values]="product"
          [box_width]="DBservice.ismobile ? undefined: (input_box_width ? input_box_width : '33.333%')"
          [submitted]="submitted" [form_data]="form_data" current_value="inventory"></app-dynamic-form>
      </div>
  
          <!-- *ngSwitchCase="'category_mapping'" -->
          <div *ngIf="false" [id]="sidebar[3].name" class="box__ category_map">
            <div class="d__flex align-c just-s">
              <h6 class="title__">Category</h6>
              <ion-button *ngIf="true" fill="clear" class="fnt-12 ion-text-capitalize add__image__btn"
                (click)="category_modal()">Assign</ion-button>
            </div>
            <div class="search_bar" *ngIf="!DBservice.ismobile && false">
              <div class="search" (mouseleave)="search_bar = false">
                <ion-searchbar placeholder="Search Category" [(ngModel)]="search_txt"
                  (ionFocus)="get_search_values('category_map')"
                  (ionChange)="search_value($event,'category_map')"></ion-searchbar>
                
                <ul class="search_values" *ngIf="search_array && search_array.length != 0 && search_bar">
                  <li class="li_div mouse" *ngFor="let item of search_array" (click)="category_map(item,'category_map')">
                    <ion-item *ngIf="item.show" class="ion_item">{{item.category_name}}<span class="span">
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                      </span></ion-item>
                  </li>
                </ul>
              </div>
            </div>
            <div class="categories_box__ gap-10 d__flex"
              *ngIf="product.product_categories && product.product_categories.length > 0;else no_category">
              <p *ngFor="let item of product.product_categories;let i = index" class="m-0 p_title d__flex just-s">
                {{item.category_name}}
                <span (click)="remove(product.product_categories,i,'category_map')" class="span mouse">
                  <ion-icon name="close-outline"></ion-icon>
                </span>
              </p>
            </div>

            <!-- <div class="d__flex remove_lists" *ngIf="product.product_categories && product.product_categories.length > 0;else no_category">
              <div *ngFor="let c of product.product_categories;let i = index" class="categories_box__ d__flex">
                <p  class="m-0 p_title d__flex just-s">{{c.category_name}}</p>
                <span (click)="remove(product.product_categories,i,'category_map')" class="span d__flex mouse"><ion-icon name="close-outline"></ion-icon></span>
              </div>
            </div> -->
            <ng-template #no_category>
              <div class="orderss_list">
                <p class="ion-text-center fnt-13">No Category Found.!</p>
              </div>
            </ng-template>
            <!-- <div class="categories_box" *ngIf="product && product?.product_categories && product?.product_categories.length != 0">
                  <div class="box__row">
                    <div></div>
                    <div>Category Id</div>
                    <div>Category Name</div>
                  </div>
                  <div class="box__row" *ngFor="let item of product.product_categories;let i = index;">
                    <div>{{i}}</div>
                    <div>{{item.category}}</div>
                    <div>{{item.category_name}}</div>
                  </div>
                </div> -->
          </div>
  
          <div *ngIf="DBservice.variant_shown" [id]="sidebar[3].name" class="attributes box__">
            <div class="d__flex section align-c just-s ">
              <h6 class="header__">Variants</h6>
              <div class="d__flex button pos_relative">
                <!-- <ion-button *ngIf="product && (product.product_attributes && product.product_attributes.length != 0) && (product.product_images && product.product_images.length != 0)" fill="clear" class="ion-text-capitalize fnt-12 add__image__btn" (click)="attach_images()">Attach a images</ion-button> -->
                <ion-button fill="clear" class="ion-text-capitalize fnt-12 add__image__btn" (click)="add_attributes()">Add / Edit </ion-button>
                <ion-button *ngIf="product.variant_combination && product.variant_combination.length != 0" fill="clear"
                  class="ion-text-capitalize fnt-12 dropdown-box_btn" (click)="drop_down2 = !drop_down2">
                  <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                </ion-button>
                <div *ngIf="drop_down2" class="dropdown-box">
                  <ion-item button lines="none" (click)="drop_down2 = false" (click)="bulk_edit_combination()"> Edit bulk
                    Options</ion-item>
                  <!-- <ion-item button lines="none" (click)="drop_down2 = false"> Logout </ion-item> -->
                </div>
                <!-- route_id ? add_attributes() : DBservice.alert('Please save the document and then try uploading images') -->
              </div>
            </div>
            <!-- <div class="section__1" *ngIf="product && (product.product_attributes && (product.product_attributes.length != 0 || product.product_attributes.length == 0)) && (product.variant_combination && product.variant_combination.length != 0)"> -->
            <div class="section__1" *ngIf="product && (product.product_attributes && (product.product_attributes.length != 0 || product.product_attributes.length == 0))">
              <div *ngIf="product.variant_combination && product.variant_combination.length != 0 ;else no_combinations;">
                <div *ngIf="check_box" class="update_all d__flex">
                  <ion-input type="number" placeholder="Enter price" [(ngModel)]="product.price"></ion-input>
                  <ion-input type="number" placeholder="Enter Quantity" [(ngModel)]="product.stock"></ion-input>
                  <ion-button (click)="save_all_price(product,check_box)" fill="clear">Save</ion-button>
                </div>
                <div class="Fields-7" *ngIf="false && !is_not_shown && !DBservice.ismobile">
                  <div class="table__data d__flex table__header">
                    <div class="txt-center">
                      <ion-checkbox class="check__box" (click)="check_box__()"></ion-checkbox>
                    </div>
                    <div>Image</div>
                    <div>Category Name</div>
                    <div class="">SKU</div>
                    <div class="">Price</div>
                    <div class="">Quantity</div>
                    <div class="">Is Active</div>
                  </div>
                  <!-- ///#scrollMe (scroll)="onScroll($event)" -->
                  <div class="orderss_list">
                    <div class="main-item mouse" *ngFor="let data of product.variant_combination; let index = index;"
                      lines="none">
                      <div class="table__data d__flex align-c table__items">
                        <div class="txt-center">
                          <ion-checkbox [checked]="check_box" class="check__box box__icon"></ion-checkbox>
                        </div>
                        <div class="Product__Img">
                          <img [src]="DBservice.product_img(data.detail_thumbnail)">
                        </div>
                        <div>
                          <p class="mb0" [innerHtml]="data.varient_json"></p>
                        </div>
                        <div>{{data.sku ? data.sku : '-'}}</div>
                        <div class="mr10">
                          <ion-input class="border_class" type="number" [(ngModel)]="data.price"></ion-input>
                          <!-- {{data.price |currency:DBservice.website_settings.currency }} -->
                        </div>
                        <div>
                          <ion-input class="border_class" type="number" [(ngModel)]="data.stock"></ion-input>
                          <!-- {{data.stock}} -->
                        </div>
                        <!-- <div>
                                <ion-checkbox class="check__box" [checked]="data.is_active"></ion-checkbox>
                              </div> -->
                        <ion-item lines="none">
                          <ion-toggle mode="ios" (ionChange)="changeTest($event,data.is_active)"></ion-toggle>
                          <!--[(ngModel)]="data.is_active" <ion-label>Veg Only</ion-label> -->
                        </ion-item>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Fields-7" *ngIf="is_not_shown || !DBservice.ismobile || DBservice.ismobile">
                  <ion-list class="p0 mouse" lines="none">
                    <ion-item (click)="edit_combination(data,index)"
                      *ngFor="let data of product.variant_combination; let index = index;" class="bb">
                      <ion-thumbnail slot="start">
                        <img *ngIf="data.image" [src]="DBservice.product_img(data.image)">
                        <img *ngIf="!data.image" [src]="DBservice.product_img(data.image)">
                      </ion-thumbnail>
                      <ion-label >
                        <h6 *ngIf="data.option_value" class="headertexth6">{{data.option_value}}</h6>
                        <p *ngIf="data.attribute_html" class="mb0 inner_html" [innerHtml]="data.attribute_html"></p>
                        
                        <div class="d__flex w_sku">
                          <h4 *ngIf="data.weight" class="small_name sku m-0">	Weight (In KG) : <span>{{data.weight}}</span></h4>
                          <h4 *ngIf="data.sku" class="small_name sku m-0">SKU : <span>{{data.sku}}</span></h4>
                          <h4 *ngIf="data.uom" class="small_name sku m-0">UOM : <span>{{data.uom}}</span></h4>
                        </div>

                        <!-- <h6 *ngIf="data.option_value" class="headertexth6">{{data.option_value}}</h6> -->
                        <!-- <p *ngIf="false" class="pfont">{{data.price | currency: DBservice.currency}} <span>Stock {{data.stock}}</span></p> -->
                      </ion-label>
                      <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
                      <!-- <ion-label class="w100">
                        <h6 *ngIf="data.option_value">Option: {{data.option_value}}</h6>
                        <p *ngIf="data.varient_json" class="mb0 inner_html" [innerHtml]="data.varient_json"></p>
                        <ion-button class="del_btn" size="small" fill="clear" (click)="del_options(data,index)" color="danger">
                          <ion-icon color="danger" src="assets/icons/delete.svg"></ion-icon>
                        </ion-button>
                        <div class="d__flex">
                          <p class="flex50">Price</p>
                          <p class="flex50">Stock</p>
                        </div>
                        <div class="d__flex">
                          <ion-input class="input_class" type="number" [(ngModel)]="data.price"></ion-input>
                          <ion-input class="input_class" type="number" [(ngModel)]="data.stock"></ion-input>
                        </div>
                      </ion-label> -->
                    </ion-item>
                  </ion-list>
                </div>
              </div>
              <div *ngIf="product.with_out_combo && product.with_out_combo.length != 0 && product.variant_combination && product.variant_combination.length != 0 ">
                <div class="product_attributes__" *ngFor="let data of product.with_out_combo; let index = index;"
                  lines="none">
                  <h5 class="m-0 h5 bold_name-14">{{data.attribute}}</h5>
                  <div class="Fields-6" *ngIf="false && !is_not_shown && !DBservice.ismobile">
                    <div class="table__data d__flex table__header">
                      <div class="txt-center">
                        <ion-checkbox class="check__box" (click)="check_box = !check_box"></ion-checkbox>
                      </div>
                      <div>Image</div>
                      <div>Category Name</div>
                      <!-- <div class="">SKU</div> -->
                      <div class="">Is Pre Selected</div>
                      <div class="">Price</div>
                      <div class="">Quantity</div>
                    </div>
                    <!-- ///#scrollMe (scroll)="onScroll($event)" -->
                    <div *ngIf="data.options && data.options.length != 0 ;else no_options" class="orderss_list">
                      <div *ngFor="let options_ of data.options" class="main-item mouse">
                        <div class="table__data d__flex align-c table__items">
                          <div class="txt-center">
                            <ion-checkbox [checked]="check_box" class="check__box box__icon"></ion-checkbox>
                          </div>
                          <div class="Product__Img">
                            <img *ngIf="options_.image" [src]="DBservice.product_img(options_.image)">
                          </div>
                          <div>
                            <h6>{{options_.option_value}}</h6>
                          </div>
                          <!-- <div>{{options_.sku ? options_.sku : '-'}}</div> -->
                          <div>
                            <ion-checkbox class="check__box" [checked]="options_.is_pre_selected == 1"></ion-checkbox>
                          </div>
                          <div>
                            <ion-input class="border_class" type="number" [(ngModel)]="options_.price"></ion-input>
                          </div>
                          <!-- <div>{{data.price |currency:DBservice.website_settings.currency }}</div> -->
                          <div>
                            <ion-input class="border_class" type="number" [(ngModel)]="options_.quantity"></ion-input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #no_options>
                      <div class="orderss_list">
                        <p class="ion-text-center">No Options Found.!</p>
                      </div>
                    </ng-template>
                  </div>
                  <!--DBservice.ismobile-->
                  <div class="Fields-6" *ngIf="true">
                    <ion-list  class="d__flex remove_lists br5" *ngIf="data.options && data.options.length != 0 ;else no_options">

                      <div *ngFor="let c of data.options;let i = index" class="categories_box__ d__flex">
                        <p  class="m-0 p_title d__flex just-s">{{c.option_value}}</p>
                        <span (click)="data.options.splice(i,1)" class="span d__flex mouse"><ion-icon name="close-outline"></ion-icon></span>
                      </div>

                      <!-- <div class="categories_box__ gap-10 d__flex">
                        <p *ngFor="let c of data.options;let i = index" class="m-0 p_title d__flex just-s">
                          {{c.option_value}}
                          <span (click)="data.options.splice(i,1)" class="span mouse">
                            <ion-icon name="close-outline"></ion-icon>
                          </span>
                        </p>
                      </div> -->
                      <!-- <ion-item lines="none" *ngFor="let options_ of data.options; let index = index;">
                        <ion-label class="w100">
                            <h6>Option: {{options_.option_value}}</h6>
                            <div class="d__flex">
                              <div class="flex-50 d__flex">
                              <ion-checkbox class="check__box m-r0" [checked]="options_.is_pre_selected"></ion-checkbox>
                              <ion-label class="pt8">Pre Selected</ion-label>
                              </div>
                              <div class="flex-50 d__flex">
                                <ion-label class="active_txt">Active</ion-label>
                              <ion-toggle mode="ios" (ionChange)="changeTest($event,data.is_active)"></ion-toggle>
                              </div>
                            </div>
                          </ion-label>
                      </ion-item> -->
                    </ion-list>
                    <ng-template #no_options>
                      <div class="orderss_list">
                        <p class="ion-text-center">No Options Found.!</p>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <ng-template #no_combinations>
                <div *ngIf="product.product_attributes && product.product_attributes.length != 0; else no_item">
                  <div class="product_attributes__" *ngFor="let data of product.product_attributes; let index = index;"
                    lines="none">
                    <h5 class="m-0 h5 bold_name-14">{{data.attribute}}</h5>
                    <div class="Fields-6" *ngIf="false && !is_not_shown">
                      <div class="table__data d__flex table__header">
                        <div class="txt-center">
                          <ion-checkbox class="check__box" (click)="check_box = !check_box"></ion-checkbox>
                        </div>
                        <div>Image</div>
                        <div>Category Name</div>
                        <!-- <div class="">SKU</div> -->
                        <div class="">Is Pre Selected</div>
                        <div class="">Price</div>
                        <div class="">Quantity</div>
                      </div>
                      <!-- ///#scrollMe (scroll)="onScroll($event)" -->
                      <div *ngIf="data.options && data.options.length != 0 ;else no_options" class="orderss_list">
                        <div *ngFor="let options_ of data.options" class="main-item mouse">
                          <div class="table__data d__flex align-c table__items">
                            <div class="txt-center">
                              <ion-checkbox [checked]="check_box" class="check__box box__icon"></ion-checkbox>
                            </div>
                            <div class="Product__Img">
                              <img *ngIf="options_.image" [src]="DBservice.product_img(options_.image)">
                            </div>
                            <div>
                              <h6>{{options_.option_value}}</h6>
                            </div>
                            <!-- <div>{{options_.sku ? options_.sku : '-'}}</div> -->
                            <div>
                              <ion-checkbox class="check__box" [checked]="options_.is_pre_selected == 1"></ion-checkbox>
                            </div>
                            <div>
                              <ion-input type="number" [(ngModel)]="options_.price"></ion-input>
                            </div>
                            <!-- <div>{{data.price |currency:DBservice.website_settings.currency }}</div> -->
                            <div>
                              <ion-input type="number" [(ngModel)]="options_.quantity"></ion-input>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ng-template #no_options>
                        <div class="orderss_list">
                          <p class="ion-text-center">No Options Found.!</p>
                        </div>
                      </ng-template>
                    </div>
                    <div class="Fields-6" *ngIf="is_not_shown || !DBservice.ismobile || DBservice.ismobile">
                      <ion-list  class="d__flex remove_lists list__" *ngIf="data.options && data.options.length != 0 ;else no_options">
                        <div *ngFor="let c of data.options;let i = index" class="categories_box__ d__flex">
                          <p  class="m-0 p_title d__flex just-s">{{c.option_value}}</p>
                          <span (click)="remove_options(data,i)" class="span d__flex mouse"><ion-icon name="close-outline"></ion-icon></span>
                        </div>
                        <!-- <div class="categories_box__ gap-10 d__flex">
                          <p *ngFor="let c of data.options;let i = index" class="m-0 p_title d__flex just-s">
                            {{c.option_value}}
                            <span (click)="remove_options(data,i)" class="span mouse">
                              <ion-icon name="close-outline"></ion-icon>
                            </span>
                          </p>
                        </div> -->
                        <!-- <ion-item  lines="none" *ngFor="let options_ of data.options; let index = index;">
                          <ion-label class="w100">
                            <h6>Option: {{options_.option_value}}</h6>
                            <div class="d__flex">
                              <div class="flex-50 d__flex">
                              <ion-checkbox class="check__box m-r0" [checked]="options_.is_pre_selected"></ion-checkbox>
                              <ion-label class="pt8">Pre Selected</ion-label>
                              </div>
                              <div class="flex-50 d__flex">
                                <ion-label class="active_txt">Active</ion-label>
                              <ion-toggle mode="ios" (ionChange)="changeTest($event,data.is_active)"></ion-toggle>
                              </div>
                            </div>
                          </ion-label>
                        </ion-item> -->
                      </ion-list>
                      <ng-template #no_options>
                        <div class="orderss_list">
                          <p class="ion-text-center">No Options Found.!</p>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <ng-template #no_item>
                  <p class="ion-text-center no_attr">No Attributes Found.!</p>
                </ng-template>
              </ng-template>
            </div>
        </div>
      <!-- shipping Info -->
      <!-- <div *ngIf="false" [id]="sidebar[4].name" class="box__" [class.pad-bbm_shipping]="!DBservice.ismobile">
        [current_value]="current_value"
        <app-dynamic-form [myform]="product_form" [form_values]="product"
          [box_width]="DBservice.ismobile ? undefined: (input_box_width ? input_box_width : '33.333%')"
          [submitted]="submitted" [form_data]="form_data" current_value="shipping_info"></app-dynamic-form>
      </div> -->
      <!-- <div [id]="sidebar[4].name" class="box__" [class.pad-bbm_shipping]="!DBservice.ismobile">
        <div class="d__flex align-c just-s">
          <h6 class="title__">Return Policy</h6>
          <ion-button class="manual-btn" (click)="open_return()">Create Your Policy</ion-button>
          <ion-button *ngIf="true" fill="clear" class="fnt-12 ion-text-capitalize add__image__btn"(click)="open_return()">Assign</ion-button>
        </div>
        <div *ngIf="policy_list && policy_list.length != 0;else no_policy_list">
          <ion-list class="p0 mouse" lines="none">
            <ion-item class="" *ngFor="let item of policy_list">
              <ion-label class="m-0">
                <h6 class="headertexth6">{{item.heading}} <span *ngIf="item.no_of_days">/</span> {{item.no_of_days}}</h6>
                <p class="pfont">{{item.description}}</p>
              </ion-label>
              <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
            </ion-item>
          </ion-list>
        </div>
        <ng-template #no_policy_list>
          <ion-list *ngIf="product.return_title" class="p0 mouse" lines="none">
            <ion-item class="">
              <ion-label class="m-0">
                <h6 class="headertexth6">{{product.return_title}}</h6>
                <p class="pfont">{{product.return_description}}</p>
              </ion-label>
              <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
            </ion-item>
          </ion-list>
          <div *ngIf="!product.return_title" class="orderss_list">
            <p class="ion-text-center fnt-13">No Return Policy Found.!</p>
          </div>
        </ng-template>
      </div> -->
      <!-- <div [id]="sidebar[5].name" class="box__" [class.pad-bbm_shipping]="!DBservice.ismobile">
        <div class="d__flex align-c just-s">
          <h6 class="title__">Replacement Policy</h6>
          <ion-button class="manual-btn" (click)="open_return()">Create Your Policy</ion-button>
          <ion-button *ngIf="true" fill="clear" class="fnt-12 ion-text-capitalize add__image__btn"(click)="open_replacement()">Assign</ion-button>
        </div>
        <div *ngIf="replacement_list && replacement_list.length != 0;else no_replacement_policy_list">
          <ion-list class="p0 mouse" lines="none">
            <ion-item class="" *ngFor="let item of replacement_list">
              <ion-label class="m-0">
                <h6 class="headertexth6">{{item.heading}}</h6>
                <p class="pfont">{{item.description}}</p>
              </ion-label>
              <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
            </ion-item>
          </ion-list>
        </div>
        <ng-template #no_replacement_policy_list>
           <ion-list *ngIf="product.replacement_title" class="p0 mouse" lines="none">
            <ion-item class="">
              <ion-label class="m-0">
                <h6 class="headertexth6">{{product.replacement_title}}</h6>
                <p class="pfont">{{product.replacement_description}}</p>
              </ion-label>
              <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
            </ion-item>
          </ion-list>
          <div *ngIf="!product.replacement_title" class="orderss_list">
            <p class="ion-text-center fnt-13">No Replacement Policy Found.!</p>
          </div>
        </ng-template>
      </div> -->
  
      <!-- *ngSwitchCase="'brands'" border_bottom_none -->
      <div [id]="sidebar[3].name" class="box__  category_map">
        <div class="d__flex align-c just-s" *ngIf="!DBservice.ismobile && false">
          <h6 class="title__">Brands</h6>
          <ion-button *ngIf="false" fill="clear" class="fnt-12 ion-text-capitalize add__image__btn"
            (click)="category_modal()">Assign Category</ion-button>
        </div>
        <div class="search_bar" *ngIf="!DBservice.ismobile && false">
          <div class="search" (mouseleave)="search_bar_brands = false">
            <ion-searchbar placeholder="Search Brands" [(ngModel)]="search_txt_brands"
              (ionFocus)="get_search_values('brands')" (ionChange)="search_value($event,'brands')"></ion-searchbar>
            <!--  -->
            <ul class="search_values" *ngIf="brands_search_array && brands_search_array.length != 0 && search_bar_brands">
              <li class="li_div mouse" *ngFor="let item of brands_search_array" (click)="category_map(item,'brands')">
                <ion-item *ngIf="item.show" class="ion_item">{{item.brand_name}}<span class="span">
                    <ion-icon name="chevron-forward-outline"></ion-icon>
                  </span></ion-item>
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="false && product.product_brands" class="d__flex remove_lists">
          <div *ngFor="let c of product.product_brands;let i = index" class="categories_box__ d__flex">
            <p  class="m-0 p_title d__flex just-s">{{c.brand_name}}</p>
            <span (click)="remove(product.product_brands,i,'brands')"  class="span d__flex mouse"><ion-icon name="close-outline"></ion-icon></span>
          </div>
        </div>
       
        <!-- <div *ngIf="!DBservice.ismobile && false" class="categories_box__ gap-10 d__flex">
          <p *ngFor="let item of product.product_brands;let i = index" class="m-0 p_title d__flex just-s">
            {{item.brand_name}}
            <span (click)="remove(product.product_brands,i,'brands')" class="span mouse">
              <ion-icon name="close-outline"></ion-icon>
            </span>
          </p>
        </div> -->
        <!--DBservice.ismobile-->
        <div *ngIf="true">
          <div class="d__flex align-c just-s">
            <h6 class="title__">Brands</h6>
            <ion-button class="fnt-12 ion-text-capitalize add__image__btn" fill="clear" (click)="open_brands()">Assign
            </ion-button>
          </div>

         <div  class="d__flex remove_lists" *ngIf="product.product_brands && product.product_brands.length > 0;else no_brands">
          <div *ngFor="let c of product.product_brands;let i = index" class="categories_box__ d__flex">
            <p  class="m-0 p_title d__flex just-s">{{c.brand_name}}</p>
            <span (click)="close_brand(c,i)" class="span d__flex mouse"><ion-icon name="close-outline"></ion-icon></span>
          </div>
         </div> 


          <!-- <div class="categories_box__ gap-10 d__flex"
            *ngIf="product.product_brands && product.product_brands.length > 0;else no_brands">
            <p class="m-0 p_title d__flex just-s" *ngFor="let p of product.product_brands;index as i">{{p.brand_name}}
              <span class="mouse span">
                <ion-icon (click)="close_brand(p,i)" name="close-outline"></ion-icon>
              </span></p>
          </div> -->
        </div>
      </div>
      <ng-template #no_brands>
        <div class="orderss_list">
          <p class="ion-text-center fnt-13">No Brands Found.!</p>
        </div>
      </ng-template>
      <!-- *ngSwitchCase="'variants'" --> 

  
      <div *ngIf="false" [id]="sidebar[8].name" class="Specification box__">
        <div class="d__flex section align-c just-s">
          <h6 class="header__">Specification</h6>
          <div class="d__flex button">
            <ion-button fill="clear" class="ion-text-capitalize fnt-12 add__image__btn"
              (click)="add_specification(product.product_specification_attributes)">Add New</ion-button>
            <!-- <ion-button fill="clear" class="ion-text-capitalize fnt-12 add__image__btn" (click)="add_attributes()">Add / Edit Attribute</ion-button> -->
            <!-- route_id ? add_attributes() : DBservice.alert('Please save the document and then try uploading images') -->
          </div>
        </div>
  
  
        <div >
          <div *ngIf="product.product_specification_attributes && product.product_specification_attributes.length != 0 ;else no_options">
            <ion-list *ngFor="let val of product.product_specification_attributes;index as i" class="p0 mouse" lines="none">
              <ion-item (click)="edit_spec(product.product_specification_attributes,i,val)" class="bb" >
                <ion-label >
                  <h6 class="headertexth6">{{val.spec_group_name}} / {{val.specification_attribute}}</h6>
                  <!-- <p  class="mb0 inner_html" ></p> -->
                  <!-- <h6 *ngIf="data.option_value" class="headertexth6">{{data.option_value}}</h6> -->
                  <p class="pfont">{{val.options}}</p>
                
                </ion-label>
                <ion-button *ngIf="!DBservice.ismobile && false" size="small" fill="clear" (click)="modify_specs(val,i,'delete')" color="danger">
                  <ion-icon color="danger" src="assets/icons/delete.svg"></ion-icon>
                </ion-button>
                <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
              </ion-item>
              
            </ion-list>
          </div>
          <ng-template #no_options>
            <div class="orderss_list">
              <p class="ion-text-center fnt-13">No Specifications Found.!</p>
            </div>
          </ng-template>
          </div>
  
        <!-- <div class="table" *ngIf="!DBservice.ismobile">
          <table>
            <tr>
              <th></th>
              <th>Group</th>
              <th>Title</th>
              <th>Description</th>
            </tr>
            <tr *ngFor="let data of product.product_specification_attributes;let i = index">
              <td>{{i + 1}}</td>
              <td
                *ngIf="specifications && specifications.specifications_group && specifications.specifications_group.length != 0">
                <select class="form-input form-select" interface="popover"
                  [(ngModel)]="data.spec_group_name ? data.spec_group_name : specifications.specifications_group[0].specification_group_name"
                  [value]="data.spec_group_name ? data.spec_group_name : specifications.specifications_group[0].specification_group_name">
                  <option *ngFor="let c of specifications.specifications_group" value="{{c.specification_group_name}}">
                    {{c.specification_group_name}}</option>
                </select>
              </td>
              <td
                *ngIf="specifications && specifications.specifications_attributes && specifications.specifications_attributes.length != 0">
                <select class="form-input form-select" interface="popover"
                  [(ngModel)]="data.specification_attribute ? data.specification_attribute : specifications.specifications_attributes[0].attribute_name"
                  [value]="data.spec_group_name ? data.spec_group_name : specifications.specifications_attributes[0].attribute_name">
                  <option *ngFor="let c of specifications.specifications_attributes" value="{{c.attribute_name}}">
                    {{c.attribute_name}}</option>
                </select>
              </td>
              <td>
                <ion-input [(ngModel)]="data.options"></ion-input>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="DBservice.ismobile">
          <ion-list lines="full">
            <div class="div" *ngFor="let val of specification;index as i">
              <div class="spec_btns">
                <ion-button size="small" fill="clear" (click)="modify_specs(val,i,'edit')" color="success">
                  <ion-icon color="success" src="assets/icons/edit.svg"></ion-icon>
                </ion-button>
                <span style="margin-top:'6px'"> | </span>
                <ion-button size="small" fill="clear" (click)="modify_specs(val,i,'delete')" color="danger">
                  <ion-icon color="danger" src="assets/icons/delete.svg"></ion-icon>
                </ion-button>
              </div>
              <div class="inner_spec">
                <div class="d__flex">
                  <h6 style="font-size:'15px'">Group <span style="position:'fixed';margin-left:'2px'">:</span> </h6>
                  <p class="lab">{{val.spec_group_name}}</p>
                </div>
                <div class="d__flex">
                  <h6 style="font-size:'15px'">Attribute <span style="position:'fixed';margin-left:'2px'">:</span> </h6>
                  <p class="lab">{{val.specification_attribute}}</p>
                </div>
                <div class="d__flex">
                  <h6 style="font-size:'15px'">Description <span style="position:'fixed';margin-left:'2px'">:</span> </h6>
                  <p class="lab">{{val.options}}</p>
                </div>
              </div>
            </div>
          </ion-list>
        </div> -->
      </div>
  
      <div *ngIf="false && title == 'Edit'" [id]="sidebar[7].name" class="box__ seo" >
        <!-- [current_value]="current_value" -->
        <app-dynamic-form [myform]="product_form" [form_values]="product"
          [box_width]="DBservice.ismobile ? '100%': (input_box_width ? input_box_width : '33.333%')"
          [submitted]="submitted" [form_data]="form_data" current_value="seo"></app-dynamic-form>
      </div>
  
      <!-- </ng-container> -->
    </div>
  </div>
  
  <div class="ion-footer" *ngIf="DBservice.ismobile || is_not_shown">
    <ion-button fill="clear" class="save-btn" (click)="post_product()" style="color: #fff;">
      <ion-icon src="assets/icon/{{title == 'Add'?'save.svg':'save.svg'}}"></ion-icon>
      {{title == 'Add'?'Save':'Update'}}
    </ion-button>
  </div>
</div>

<!-- <ion-footer class="mouse ion-footer" *ngIf="false && DBservice.ismobile || is_not_shown">
  <ion-toolbar>
    <ion-buttons class="just-c">
      <ion-button class="save-btn" (click)="post_product()" style="color: #fff;">
        <ion-icon src="assets/icon/{{title == 'Add'?'save.svg':'save.svg'}}"></ion-icon>
        {{title == 'Add'?'Save':'Update'}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer> -->